import { error, defaultError } from "./error";

export const required = (value: string) => {
  return value.toString().length === 0 ? error("required") : defaultError();
};

export const checked = (value: boolean) => {
  return value ? defaultError() : error("must be checked");
};

export const oneChecked = (value: string[]) => {
  return value.length > 0 ? defaultError() : error("must check at least one");
};

export const validCaliforniaApplicationId = (value: string) => {
  if (value.charAt(0) !== "N") {
    return error("must begin with N");
  }

  const numberOfChars = 10;
  if (value.length !== numberOfChars) {
    return error("must be " + numberOfChars + " characters");
  }

  return defaultError();
};

export const validAddress = (value: string) => {
  const max = 50;
  if (value.length > max) {
    return error("maximum " + max + " characters");
  }

  return defaultError();
};

export const validPostalCode = (value: string) => {
  const postalCodeRegEx = /^[0-9]{5}(?:-[0-9]{4})?$/;
  //const postalCodeRegEx =  /^[a-zA-Z0-9]{5,7}$/;
  const canadianZipCodeRegExp =
    /^[ABCDEGHJKLMNPRSTVXY][0-9][ABCEGHJKLMNPRSTVWYZ] [0-9][ABCEGHJKLMNPRSTVWXYZ][0-9]$/;
  const canadianZipCodeRegExp1 =
    /^[ABCDEGHJKLMNPRSTVXY][0-9][ABCEGHJKLMNPRSTVWYZ][0-9][ABCEGHJKLMNPRSTVWXYZ][0-9]$/;

  if (
    !postalCodeRegEx.test(value) &&
    !canadianZipCodeRegExp1.test(value) &&
    !canadianZipCodeRegExp.test(value)
  ) {
    return error("invalid postal code");
  }

  return defaultError();
};

export const validPhone = (value: string) => {
  if (!value.match(/\d/g)) {
    return error("must only contain numbers");
  }

  const minimum = 10;
  if (value.length < minimum) {
    return error("must be at least " + minimum + " digits");
  }

  return defaultError();
};

export const validateWithData = async (code: string, value: any, validators: any[]) => {
  let errorObj = defaultError();

  for (const el of validators) {
    if (el.name === "minimumCharacters" && !errorObj.active) {
      errorObj = evaluateCharacterConstraint(value, el, el.failMessage);
    } else if (el.validator.type === "regEx" && value.length > 0 && !errorObj.active) {
      errorObj = evaluateRegEx(value, el.validator.regularExpression, el.failMessage);
    } else if (el.name === "maximumCharacters" && !errorObj.active) {
      errorObj = evaluateCharacterConstraint(value, el, el.failMessage);
    } else if (el.validator.type === "remote") {
      const response = await fetch(process.env.API_URL + "/APIValidation/validate", {
        method: "POST",
        headers: { "Content-Type": "application/json; charset=utf-8" },
        body: JSON.stringify({
          validationName: code,
          validationParameters: code === "georgiaApplicationId" ? value : { value },
        }),
      });

      const json = await response.json();
      if (!json.validationPassed) {
        errorObj = error(json.validationMessage ? json.validationMessage : "validation failed");
      }
    } else if (el.validator.type === "dateYearDifference" && !errorObj.active) {
      errorObj = evaluateDateYearDifferenceConstraint(value, el, el.failMessage);
    }
  }

  return errorObj;
};

const evaluateRegEx = (value: string, regExString: string, message: string) => {
  const regEx = new RegExp(regExString);
  if (!regEx.test(value)) {
    return error(message);
  }
  return defaultError();
};

const evaluateCharacterConstraint = (value: string, validator: any, message: string) => {
  if (validator.validator.type === "greaterThan") {
    return value.length >= validator.value ? defaultError() : error(message);
  } else if (validator.validator.type === "lessThan") {
    return value.length <= validator.value ? defaultError() : error(message);
  }
};

const evaluateDateYearDifferenceConstraint = (value: string, validator: any, message: string) => {
  // calculate date diff
  const today = new Date();
  const dateValue = new Date(value);
  const yearsDiff = today.getFullYear() - dateValue.getFullYear();

  if (validator.validator.name === "dateYearDiffGreaterThan") {
    return yearsDiff >= validator.value ? defaultError() : error(message);
  } else if (validator.validator.name === "dateYearDiffLessThan") {
    return yearsDiff <= validator.value ? defaultError() : error(message);
  }
};
